module.exports = __webpack_public_path__ + "img/logo.7bb4c9f9.png";